<template>
  <div>
    <section v-if="loading">
      <spinner-loader :loading="loading" />
    </section>

    <section v-else class="content-container">
      <div>
        <b-row class="search-header" align-h="center">
          <b-col md="6" class="my-1">
            <b-input-group>
              <b-form-input v-model="filter" :placeholder="$t('search')" />
            </b-input-group>
          </b-col>

          <b-col md="4">
            <b-button
              v-b-modal.discountCodeModal
              style="margin-top:4px;"
            >
              New Discount Code
            </b-button>
          </b-col>
        </b-row>
      </div>

      <b-table
        v-if="!loading"
        :items="discountCodes"
        :fields="fields"
        :filter="filter"
        ref="modsTable"
        hover
        striped
        class="modifier-table"
        fixed
        @row-clicked="rowClicked"
      >
      </b-table>

      <div v-else class="fixed-center">
        <spinner-loader/>
      </div>
      <!-- </div> -->
    </section>

    <discount-code-modal
      ref="discountCodeModal"
      @submit="submitDiscountCode"
      @delete="deleteDiscountCode"
    />
  </div>
</template>

<script>
import {
  mapGetters,
  mapState,
  mapActions
} from 'vuex';

import axios from 'axios';
import API from '@/api';

import { MODIFIER_RATE_TYPES, MODIFIER_TYPES } from '@/config/constants'
import cloneDeep from 'lodash.clonedeep';

export default {
  name: 'DiscountCodes',

  components: {
    DiscountCodeModal: () => import('@/components/modals/DiscountCodeModal'),
    SpinnerLoader: () => import('@/components/widgets/SpinnerLoader')
  },

  async mounted() {
    this.getDiscountCodes()
  },

  data() {
    return {
      discountCodes: [],
      fields: [
        {
          label: 'Name',
          key: 'name'
        },
        {
          label: 'Description',
          key: 'description'
        },
        {
          label: 'Default Rate',
          key: 'rate',
          formatter: (value, field, row) => {
            const formattedValue = parseFloat(value).toFixed(2);

            if (row.type_id === MODIFIER_RATE_TYPES.PERCENTAGE) {
              return `${formattedValue}%`;
            }

            if (row.type_id === MODIFIER_RATE_TYPES.FIXED) {
              return `$${formattedValue}`;
            }

            return formattedValue
          }
        },
        {
          key: 'code'
        },
        {
          label: 'Enabled',
          key: 'is_enabled',
          formatter: (value, field, row) => {
            return value
              ? 'Yes'
              : 'No'
          }
        }
      ],
      filter: '',
      loading: false
    }
  },

  methods: {
    getDiscountCodes() {
      this.loading = true;

      axios
        .get(`${API.BASE_URL}/discountcodes`, API.RequestHeaders())
        .then(res => {
          this.discountCodes = res.data;
        })
        .finally(err => {
          this.loading = false;
        });
    },

    rowClicked(discountCode) {
      this.$refs.discountCodeModal.open(discountCode);
    },

    submitDiscountCode(params) {
      let id = params.id;

      delete params.id;

      if (!id) {
        this.addDiscountCode(params);
        return;
      }

      this.updateDiscountCode(id, params);
    },

    addDiscountCode(params) {
      this.loading = true;
      axios
        .post(`${API.BASE_URL}/discountcodes`, params, API.RequestHeaders())
        .then(res => {
          this.getDiscountCodes();
        })
        .finally(err => {
          this.loading = false;
        });
    },

    updateDiscountCode(id, params) {
      this.loading = true;
      axios
        .put(`${API.BASE_URL}/discountcodes/${ id }`, params, API.RequestHeaders())
        .then(res => {
          this.getDiscountCodes();
        })
        .finally(err => {
          this.loading = false;
        });
    },

    deleteDiscountCode(item) {
      axios
        .delete(`${API.BASE_URL}/discountcodes/${ item.id }`, API.RequestHeaders())
        .then(() =>{
          this.infoNotification(`${ item.name } has been deleted.`)
          this.getDiscountCodes();
        })
        .catch((error) => {
          this.errorNotification(`Failed to delete discount code`)
        })
    }
  }
};
</script>
